import { FlowRoute, FlowRouteCategory, FlowActions } from '@eneco/flows/types';

import { FlowConsumerContextEnergy } from './context';
import { shouldSkipIfTestVariantIsActive, shouldSkipWhenNoEnergyUpsellProductsAvailable } from './oxxio/skippingRules';
import {
  DeliveryDateStepOxxio,
  OfferStepOxxio,
  OverviewStepOxxio,
  SummaryStepOxxio,
  SustainableChoiceStepOxxio,
} from './oxxio/steps';
import { flowActions, addressRoute, createUsageCalculationRoutes, detailsTailRoutes } from './shared/flowConfig';
import { AddressDetailsStep, EnergyChoiceStep, MovingStep } from './shared/steps';

export const initialContext: FlowConsumerContextEnergy = {};

export const routes: FlowRoute<FlowConsumerContextEnergy>[] = [
  addressRoute,

  {
    id: 'ENERGY_CHOICE',
    path: '/energiekeuze/',
    category: FlowRouteCategory.Calculation,
    component: EnergyChoiceStep,
    actions: ['resetUsageValues'],
  },

  ...createUsageCalculationRoutes({ includeWarmthRules: false }),

  {
    id: 'MOVING',
    path: '/verhuizen/',
    category: FlowRouteCategory.Calculation,
    component: MovingStep,
    skippingRules: [shouldSkipIfTestVariantIsActive],
  },

  {
    id: 'OFFER',
    path: '/productkeuze/looptijd/',
    category: FlowRouteCategory.Overview,
    component: OfferStepOxxio,
  },

  {
    id: 'SUSTAINABLE_CHOICE',
    path: '/duurzame-keuze/',
    category: FlowRouteCategory.Overview,
    component: SustainableChoiceStepOxxio,
    skippingRules: [shouldSkipWhenNoEnergyUpsellProductsAvailable],
  },

  {
    id: 'OVERVIEW',
    path: '/overzicht/',
    category: FlowRouteCategory.Overview,
    component: OverviewStepOxxio,
  },

  {
    id: 'ADDRESS_DETAILS',
    path: '/je-gegevens/adresgegevens/',
    category: FlowRouteCategory.Details,
    component: AddressDetailsStep,
  },

  {
    id: 'DELIVERY_DATE',
    path: '/je-gegevens/start-leverdatum/',
    category: FlowRouteCategory.Details,
    component: DeliveryDateStepOxxio,
  },

  ...detailsTailRoutes,

  {
    id: 'SUMMARY',
    path: '/je-gegevens/controle-keuze/',
    category: FlowRouteCategory.Summary,
    component: SummaryStepOxxio,
  },
];

export const actions: FlowActions<FlowConsumerContextEnergy> = flowActions;
